<template>
    <Form >
        <FormItem :label="$t('l.name')">
            <Input type="text" v-model="contactThis.name" :placeholder="$t('l.name')"/>
        </FormItem>
        <FormItem :label="$t('l.mobile')">
            <Input type="text" v-model="contactThis.mobile" :placeholder="$t('l.mobile')"/>
        </FormItem>
        <FormItem :label="$t('l.e_mail')">
            <Row v-if="contactThis.email.length" style="max-height: 200px; overflow-y: auto">
                <span v-for="(em, index_e) in contactThis.email" :key="em" >
                    <Tag :closable="true" @on-close="contactThis.email.splice(index_e, 1)">{{em}}</Tag>
                    <br>
                </span>
            </Row>
            <Row ><Input type="text" :placeholder="$t('l.e_mail')" v-model="tempEmail" @keydown.native.enter.prevent="addEmail"/></Row>
        </FormItem>
        <div style="display: flex;justify-content: end">
          <Button type="primary" @click="$emit('on-close')">{{$t('l.close')}}</Button>
        </div>
    </Form>
</template>

<script>
    export default {
        name: "depart-contact-editor",
        props: {
            contact: {
                type: Object,
                default () {
                    return {
                        name: '',
                        email: '',
                        mobile: ''
                    }
                }
            }
        },
        watch: {
            contact: {
                handler (newVal, oldVal) {
                    if (!newVal) this.contactThis = {
                        name: '',
                        email: [],
                        mobile: ''
                    };
                    else this.contactThis = {
                        name: newVal.name,
                        email: newVal.email?newVal.email.split(','):[],
                        mobile: newVal.mobile
                    }
                },
                deep: true
            }
        },
        data () {
            return {
                contactThis: {
                    name: '',
                    email: [],
                    mobile: ''
                },
                tempEmail: ''
            }
        },
        methods: {
            addEmail () {
                if (!this.tempEmail || !this.tempEmail.trim()) {
                    this.$Message.warning(this.$t('l.hint14'));
                    return;
                }
                let em = this.tempEmail.trim();
                if (this.contactThis.email.includes(em)) {
                    this.$Message.warning(this.$t('l.hint15'));
                    return;
                }
                this.contactThis.email.push(em);
                this.tempEmail = '';
            }
        }
    }
</script>

<style scoped>

</style>